import { ReactNode, memo } from 'react';

import { twMerge } from 'tailwind-merge';

import './DefaultSidebar.css';

interface DefaultSidebarProps {
  children: ReactNode;
  className?: string;
}

export function DefaultSidebarBase({ children, className }: DefaultSidebarProps) {
  return (
    <div className={twMerge('default-sidebar w-[252px] border-r border-v2blueGray-200', className)}>
      {children}
    </div>
  );
}

export const DefaultSidebar = memo(DefaultSidebarBase);
